import React from "react";

const VideoItem = ({ id, imageSrc, title, views, date, likes, onClick }) => {
  const handleClick = () => {
    onClick(id);
  };

  return (
    <div className="video-item" id={id} onClick={handleClick}>
      <div className="avatar-figure">
        <img
          className="avatar"
          loading="lazy"
          width="120"
          height="90"
          src={`https://i.ytimg.com/vi/EEH4kqiYMTc/default.jpg`}
          alt="Video Thumbnail"
        />
      </div>
      <div className="avatar-caption" lang="en">
        <p className="avatar-title">
          <strong>{title}</strong>
        </p>
        {/* <p className="caption-main">
          <span>{views} Views</span>
          <em> | </em>
          <span>{date}</span>
          <em> | </em>
          <span>{likes} Likes</span>
        </p> */}
      </div>
    </div>
  );
};

const VideoList = ({ videos, onItemClick }) => {
  const handleVideoClick = (id) => {
    const video = videos.find((video) => video.id === id);
    if (video) {
      window.open(
        `https://www.youtube.com/watch?v=${video.youtubeId}`,
        "_blank"
      );
    }
  };

  return (
    <div
      className="video-tuple-list"
      style={{ overflowY: "auto", maxHeight: "400px" }}
    >
      {videos.map((video) => (
        <VideoItem
          key={video.id}
          id={video.id}
          imageSrc={video.imageSrc}
          title={video.title}
          views={video.views}
          date={video.date}
          likes={video.likes}
          onClick={handleVideoClick}
        />
      ))}
    </div>
  );
};

export default VideoList;
